
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "../Profile/connect/User";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import Loader from "../../components/Loader/Loader";
import MapToPutMarker2 from "../../components/Map/MapToPutMarker2";
import HelmetComponent from "../../components/Helmet/Helmet";
import withAuth from '../../hoc/withAuth';


function EditProfileBusiness(props) {
    const navigate = useNavigate();
    const { getUserInfo, editUser, getIsBusinessUser, deleteUserProfileImage, editUserWitoutToken, getBusinessAccountNameCheck } = useUserInfo((state) => state.actions);
    const loader = useUserInfo((state) => state.loader)
    const businessAccountNameCheck = useUserInfo((state) => state.businessAccountNameCheck)
    const isSuccessEdit = useUserInfo((state) => state.isSuccessEdit)
    const { saveUserProfilelImage } = useUserInfo((state) => state.actions)
    const isBusinessUserCheck = useUserInfo((state) => state.isBusinessUserCheck)
    const [openProfile, setOpenProfile] = useState(false);
    const userInfo = useUserInfo((state) => state.userInfo)
    const [position, setPosition] = useState([0, 0])
    const [businessAccountName, setBusinessAccountName] = useState(userInfo[0] ? userInfo[0].businessAccountName : "")
    const [businessAccountNameErr, setBusinessAccountNameErr] = useState(false)
    const [userCurrentLoc, setUserCurrentLoc] = useState(null)
    const [formErrors, setFormErrors] = useState({})
    const handleGetCurrentLocation = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log(position, "position in navigator.geolocation");

                    setUserCurrentLoc([position.coords.latitude, position.coords.longitude]);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    alert("Unable to retrieve your location.");
                }
            );
        } else {
            alert("Geolocation is not supported by your browser.");
        }
    };

    const handleOpenEditProfile = () => {
        setOpenProfile(true);
    };

    useEffect(() => {
        getUserInfo(localStorage.getItem("pelakAuthData"))
        getIsBusinessUser(localStorage.getItem("pelakAuthData"))
        if (isSuccessEdit) {
            navigate("/Profile")
        }
        setBusinessAccountName(userInfo[0] ? userInfo[0].businessAccountName : "")
    }, []);
    useEffect(() => {
        setBusinessAccountName(userInfo[0] ? userInfo[0].businessAccountName : "")
        setBusinessAccountDes(userInfo[0] ? userInfo[0].description : "")
        setAdress(userInfo[0] && userInfo[0].address ? userInfo[0].address : "")
    }, [userInfo]);


    const [file, setFile] = useState("/icons/profile-pic.svg");
    const [profileName, setProfileName] = useState()
    function handleChange(e) {
        setFile(URL.createObjectURL(e.target.files[0]));
        setProfileName(e.target.files[0])
    }


    const closeModalClickOutside = (e) => {
        setOpenProfile(false)
    }
    const [businessAccountDes, setBusinessAccountDes] = useState(
        userInfo[0] && localStorage.getItem("accountType") == 2 ? "" : userInfo[0] && userInfo[0].description ? userInfo[0].description : ""
    )

    const [adress, setAdress] = useState(userInfo[0] && userInfo[0].address ? userInfo[0].address : "")
    const [isShowMapModal, setIsShowMapModal] = useState(false)

    const sendSelectedLocation = () => {
        setIsShowMapModal(false)
    }
    const setUserLocation = (data) => {
        localStorage.setItem("userLocationInProfile", JSON.stringify({ "lat": data.lat, "long": data.lng }))
    }

    const removeProfilePic = async () => {
        await deleteUserProfileImage(Number(localStorage.getItem("pelakAuthData")))
        setFile("/icons/profile-pic.svg")
    }

    return (
        <>
            {
                loader ? (<Loader />) : (
                    <>
                        <div className="bg w-full overflow-y-auto  ">
                            <HelmetComponent title="ویرایش پروفایل" description="ویرایش پروفایل" />
                            <div className="flex w-full justify-center items-center flex-col ">
                                <div className='w-full items-center justify-center items-center py-2 z-40  relative bg-white border-b sticky top-0 hidden sm:flex lg:flex'>
                                    <h1 className='w-full text-center font-bold '>ویرایش پروفایل</h1>
                                    <div className='absolute right-4' onClick={() => {
                                        if (isBusinessUserCheck == 0) {
                                            localStorage.setItem("accountType", 1)
                                            navigate(-1)
                                        } else {
                                            navigate(-1)
                                        }
                                    }} >
                                        <img src='/icons/arrow-right.svg' alt='icon-right' className='' />
                                    </div>
                                </div>
                                <div className="contents w-full justify-center mt-3">
                                    <div className="relative flex " onClick={handleOpenEditProfile}>
                                        <img className='rounded-full shadow-sm  w-[130px] h-[130px] mb-1 mt-2'
                                            src={
                                                profileName ? file :
                                                    userInfo[0] && userInfo[0].profilePicUrl != "" ?
                                                        ((userInfo[0] && userInfo[0].profilePicUrl) && "https://api.pelakeman.com/Documents/Users/ProfilePic/" + userInfo[0].profilePicUrl)
                                                        : file
                                            } alt="عکس پروفایل" />
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            className="size-6 absolute top-[20px] right-[5px] p-[3px] bg-gray-100 rounded-full">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                                        </svg>

                                    </div>
                                </div>
                            </div>
                            {
                                userInfo.length ? (
                                    <Formik
                                        initialValues={{
                                            firstName: userInfo[0] ? userInfo[0].firstName : "",
                                            lastName: userInfo[0] ? userInfo[0].lastName : "",
                                            phoneNumber: userInfo[0] ? userInfo[0].mobileNumber : "",
                                            verificationCode: "",
                                            isShowMobileNumber: userInfo[0] && userInfo[0].isShowPhoneNumber,
                                            isCanChat: userInfo[0] && userInfo[0].isChatEnable,
                                            isShowProfile: false,
                                            businessExpertise: userInfo[0] ? userInfo[0].businessExpertise : "",
                                            nationalCode: userInfo[0] ? userInfo[0].nationalCode : "",
                                            businessAccountName: userInfo[0] ? userInfo[0].businessAccountName : "",
                                            adsMainCategoryCode: userInfo[0] && userInfo[0].adsMainCategoryCode
                                        }}
                                        validate={values => {
                                            // const values = valuesArray[0];
                                            console.log(values);
                                            
                                            const errors = {};
                                                if (values.firstName == null || values.firstName.length < 3) {
                                                    errors.firstName = 'نام معتبر نمیباشد';
                                                }
                                                if (values.lastName == null || values.lastName.length < 3) {
                                                    errors.lastName = 'نام خانوادگی معتبر نمیباشد';
                                                }


                                            // if (localStorage.getItem("accountType") == 1) {
                                            //     if (values.firstName.length < 3) {
                                            //         errors.firstName = 'نام معتبر نمیباشد';
                                            //     }
                                            //     if (values.lastName.length < 3) {
                                            //         errors.lastName = 'نام خانوادگی معتبر نمیباشد';
                                            //     }
                                            // }
                                            // else {
                                            //     if (values.nationalCode.length !== 10) {
                                            //         errors.nationalCode = 'کدملی معتبر نمیباشد';
                                            //     }
                                            //     if (!values.isShowMobileNumber && !values.isCanChat) {
                                            //         errors.isShowMobileNumber = 'لطفا یکی از راه های ارتباطی را انتخاب کنید';
                                            //     }
                                            //     if (!values.adsMainCategoryCode) {
                                            //         errors.adsMainCategoryCode = 'نوع کسب و کار را انتخاب کنید';
                                            //     }
                                            //     if (!values.businessExpertise) {
                                            //         errors.businessExpertise = 'تخصص کسب و کار  معتبر نمیباشد'
                                            //     }
                                            // }
                                            setFormErrors(errors);
                                            console.log([errors]);
                                            
                                            return errors;
                                        }}
                                        onSubmit={async (values, event, errors) => {
                                            const userAuthToken = localStorage.getItem("pelakAuthData")
                                            await editUser(0, 0, values.firstName, values.lastName, '', 
                                                '', 0, '', '', 0,
                                                '', '', '',
                                                '2020-01-01', 1,2,3, '12.345678', '12.345678',
                                                '', false, '', '',
                                                '', '', '', '', 0,
                                                '', '', '', 2, 1,
                                                false, false, false
                                            )
                                    // editUser: async (
                                    //             id, lastUserId, firstName, lastName, businessExpertise,
                                    //             businessAccountName, adsMainCategoryCode, nationalCode, email, gender,
                                    //             mobileNumber, phoneNumber, emergencyNumber,
                                    //             birthDate, country, state, city, longitudes, latitudes,
                                    //             address, isBusinessUser, description, perssonelPicUrl,
                                    //             businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
                                    //             businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
                                    //             isUpdated, isShowPhoneNumber, isChatEnable
                                    //         )

                                    // {
                                    //     "id": 0,
                                    //     "lastUserId": 0,
                                    //     "firstName": "string",
                                    //     "lastName": "string",
                                    //     "businessExpertise": "string",
                                    //     "businessAccountName": "string",
                                    //     "adsMainCategoryCode": 0,
                                    //     "nationalCode": "string",
                                    //     "email": "string",
                                    //     "gender": 0,
                                    //     "mobileNumber": "string",
                                    //     "phoneNumber": "string",
                                    //     "emergencyNumber": "string",
                                    //     "birthDate": "2025-08-12T09:16:28.411Z",
                                    //     "country": 0,
                                    //     "state": 0,
                                    //     "city": 0,
                                    //     "longitudes": 0,
                                    //     "latitudes": 0,
                                    //     "address": "string",
                                    //     "isBusinessUser": true,
                                    //     "description": "string",
                                    //     "businessAcntDescription": "string",
                                    //     "perssonelPicUrl": "string",
                                    //     "businessPicUrl": "string",
                                    //     "profilePicUrl": "string",
                                    //     "businessLicensePicUrl": "string",
                                    //     "shPicUrl": "string",
                                    //     "otherDocumnetUrl": "string",
                                    //     "nationalCardPicUrl": "string",
                                    //     "positionCode": 0,
                                    //     "businessLicenseNumber": "string",
                                    //     "instagramId": "string",
                                    //     "telegramId": "string",
                                    //     "userTypeCode": 0,
                                    //     "userRegisterStatusCode": 0,
                                    //     "registerDate": "2025-08-12T09:16:28.411Z",
                                    //     "isUpdated": true,
                                    //     "isShowPhoneNumber": true,
                                    //     "isChatEnable": true
                                    // }


                                            // if (localStorage.getItem("accountType") == 1) {
                                            //     await editUser(
                                            //         Number(localStorage.getItem("pelakAuthData")),
                                            //         // isBusinessUserCheck == 0 ? 0 : Number(localStorage.getItem("pelakAuthData")),
                                            //         values.isBusinessUser ? isBusinessUserCheck == 0 ? Number(localStorage.getItem("pelakAuthData")) : 0 : 0, values.firstName, values.lastName, values.businessExpertise,
                                            //         businessAccountName, Number(values.adsMainCategoryCode),
                                            //         values.nationalCode, userInfo[0] && userInfo[0].email, userInfo[0] && userInfo[0].gender,
                                            //         userInfo[0] && userInfo[0].mobileNumber, userInfo[0] && userInfo[0].phoneNumber, userInfo[0] && userInfo[0].emergencyNumber,
                                            //         userInfo[0] && userInfo[0].birthDate, userInfo[0] && userInfo[0].country, userInfo[0] && userInfo[0].state, userInfo[0] && userInfo[0].city,
                                            //         localStorage.getItem("userLocationInProfile") ? Number(JSON.parse(localStorage.getItem("userLocationInProfile"))[1]) : 0,
                                            //         localStorage.getItem("userLocationInProfile") ? Number(JSON.parse(localStorage.getItem("userLocationInProfile"))[0]) : 0,
                                            //         adress, false, businessAccountDes, userInfo[0].perssonelPicUrl,
                                            //         userInfo[0].businessLicensePicUrl, userInfo[0].shPicUrl, userInfo[0].otherDocumnetUrl, userInfo[0].nationalCardPicUrl, userInfo[0].positionCode,
                                            //         userInfo[0].businessLicenseNumber, userInfo[0].instagramId, userInfo[0].telegramId, userInfo[0].userTypeCode, userInfo[0].userRegisterStatusCode,
                                            //         true,
                                            //         values.isShowMobileNumber,
                                            //         values.isCanChat
                                            //     )
                                            // } else {
                                            //     if (isBusinessUserCheck != 0) {
                                            //         await editUser(
                                            //             //Number(localStorage.getItem("pelakAuthData")),
                                            //             isBusinessUserCheck == 0 ? 0 : Number(localStorage.getItem("pelakAuthData")),
                                            //             Number(localStorage.getItem("pelakAuthData")), "", "", values.businessExpertise,
                                            //             businessAccountName, Number(values.adsMainCategoryCode),
                                            //             values.nationalCode, userInfo[0] && userInfo[0].email, userInfo[0] && userInfo[0].gender,
                                            //             userInfo[0] && userInfo[0].mobileNumber, userInfo[0] && userInfo[0].phoneNumber, userInfo[0] && userInfo[0].emergencyNumber,
                                            //             userInfo[0] && userInfo[0].birthDate, userInfo[0] && userInfo[0].country, userInfo[0] && userInfo[0].state, userInfo[0] && userInfo[0].city,
                                            //             localStorage.getItem("userLocationInProfile") ? Number(JSON.parse(localStorage.getItem("userLocationInProfile"))[1]) : 0,
                                            //             localStorage.getItem("userLocationInProfile") ? Number(JSON.parse(localStorage.getItem("userLocationInProfile"))[0]) : 0,
                                            //             adress, true, businessAccountDes, userInfo[0].perssonelPicUrl,
                                            //             userInfo[0].businessLicensePicUrl, userInfo[0].shPicUrl, userInfo[0].otherDocumnetUrl, userInfo[0].nationalCardPicUrl, userInfo[0].positionCode,
                                            //             userInfo[0].businessLicenseNumber, userInfo[0].instagramId, userInfo[0].telegramId, 2, userInfo[0].userRegisterStatusCode,
                                            //             true,
                                            //             values.isShowMobileNumber,
                                            //             values.isCanChat
                                            //         )
                                            //     } else {
                                            //         await editUserWitoutToken(
                                            //             //Number(localStorage.getItem("pelakAuthData")),
                                            //             isBusinessUserCheck == 0 ? 0 : Number(localStorage.getItem("pelakAuthData")),
                                            //             Number(localStorage.getItem("pelakAuthData")), "", "", values.businessExpertise,
                                            //             businessAccountName, Number(values.adsMainCategoryCode),
                                            //             values.nationalCode, userInfo[0] && userInfo[0].email, userInfo[0] && userInfo[0].gender,
                                            //             userInfo[0] && userInfo[0].mobileNumber, userInfo[0] && userInfo[0].phoneNumber, userInfo[0] && userInfo[0].emergencyNumber,
                                            //             userInfo[0] && userInfo[0].birthDate, userInfo[0] && userInfo[0].country, userInfo[0] && userInfo[0].state, userInfo[0] && userInfo[0].city,
                                            //             localStorage.getItem("userLocationInProfile") ? Number(JSON.parse(localStorage.getItem("userLocationInProfile"))[1]) : 0,
                                            //             localStorage.getItem("userLocationInProfile") ? Number(JSON.parse(localStorage.getItem("userLocationInProfile"))[0]) : 0,
                                            //             adress, true, businessAccountDes, userInfo[0].perssonelPicUrl,
                                            //             userInfo[0].businessLicensePicUrl, userInfo[0].shPicUrl, userInfo[0].otherDocumnetUrl, userInfo[0].nationalCardPicUrl, userInfo[0].positionCode,
                                            //             userInfo[0].businessLicenseNumber, userInfo[0].instagramId, userInfo[0].telegramId, 2, userInfo[0].userRegisterStatusCode,
                                            //             true,
                                            //             values.isShowMobileNumber,
                                            //             values.isCanChat
                                            //         )
                                            //     }
                                            // }
                                            if (profileName) {
                                                await saveUserProfilelImage(localStorage.getItem("pelakAuthData"), profileName)
                                            }
                                            if (props.isShowAppEditProfileModal) {
                                                props.setIsShowEditProfileModal(false)
                                            } else {
                                                navigate("/Profile")
                                            }
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                        }) => (
                                            <Form onSubmit={handleSubmit} className='flex flex-col gap-4 2xl:px-12'>
                                                {
                                                    userInfo[0] && localStorage.getItem("accountType") == 2 ? (
                                                        <>
                                                        </>
                                                    ) : (
                                                        <>

                                                            <div className="grid md:grid gap-6 mb-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-2  lg:w-full sm:w-full md:w-w-full w-[50%] ">
                                                                <div className="flex flex-col items-start w-full">
                                                                    <label htmlFor="firstName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-500">نام</label>
                                                                    <Field name="firstName"
                                                                        className=" bg-gray-100 bg-gray-50 border border-gray-300 text-gray-900 dark:text-gray-500 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-1 " />
                                                                    <ErrorMessage name="firstName">{msg => <div className='text-[11px] text-red-600 pr-2'>{msg}</div>}</ErrorMessage>
                                                                </div>
                                                                <div className="flex flex-col items-start w-full">
                                                                    <label htmlFor="lastName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-500 ">نام خانوادگی</label>
                                                                    <Field type="text" name="lastName"
                                                                        className=" bg-gray-100 bg-gray-50 border border-gray-300 text-gray-900 dark:text-gray-500 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-1 " />
                                                                    <ErrorMessage name="lastName">{msg => <div className='text-[11px] text-red-600 pr-2'>{msg}</div>}</ErrorMessage>
                                                                </div>
                                                            </div>
                                                            <div className="grid gap-6 pb-6 md:grid-cols-2 sm:grid-cols-1  border border-[1px] border-t-0 border-l-0 border-r-0 border-gray-200 py-3 grid md:grid gap-6 mb-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-2 mt-3 py-3 lg:w-full sm:w-full md:w-w-full w-[50%]">
                                                                <div className="flex flex-col items-start w-full">
                                                                    <label htmlFor="phoneNumber" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-500 ">شماره همراه </label>
                                                                    <div className="relative flex items-center bg-gray-100  rounded-xl w-full">
                                                                        {/* <p className="absolute flex items-center justify-center left-3 text-green-600 text-[10px] h-full border-r pr-2 cursor-pointer ">ارسال کد تایید</p> */}
                                                                        <Field type="number" name="phoneNumber"
                                                                            className=" bg-gray-100 bg-gray-50 border border-gray-300 text-gray-900 dark:text-gray-500 text-sm overflow-hidden rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-1 " />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="grid grid-cols-3 sm:grid-cols-1 md:grid-cols-1">
                                                                {/* <div className="grid gap-6 md:grid-cols-1 sm:grid-cols-1 col-span-2">
                                                                    <div>
                                                                        <label htmlFor="businessAccountDes" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-500 ">توضیحات </label>
                                                                        <textarea value={businessAccountDes} onChange={(e) => setBusinessAccountDes(e.target.value)}
                                                                            rows={4} type="text" name="businessAccountDes" className="bg-gray-50 dark:bg-slate-700 border border-gray-300 text-gray-900 dark:text-gray-500 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-1" placeholder="" required />
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className="flex sm:items-center sm:flex-row md:flex-row sm:justify-between md:items-center md:justify-between flex-col  items-start justify-center ">
                                                                    <div class=" flex items-center gap-1">
                                                                        <label class="relative flex cursor-pointer items-center p-1 rounded-md text-sm">
                                                                            <Field name="isShowMobileNumber" type="checkbox" className="peer cursor-pointer appearance-none relative h-5 w-5 bg-gray-900/25  border border-gray-900 transition-all checked:border-green-500 checked:bg-green-500 rounded-md" />
                                                                        </label>
                                                                        <p className="text-sm">نمایش شماره تماس</p>
                                                                    </div>
                                                                    <div class=" flex items-center gap-1">
                                                                        <label class="relative flex cursor-pointer items-center p-1 rounded-md text-sm">
                                                                            <Field name="isCanChat" type="checkbox" className="peer cursor-pointer appearance-none relative h-5 w-5 bg-gray-900/25 border border-gray-900 transition-all checked:border-green-500 checked:bg-green-500 rounded-md" />
                                                                        </label>
                                                                        <p className="text-sm">قابلیت چت</p>
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        </>
                                                    )
                                                }


                                                {
                                                    localStorage.getItem("accountType") == 2 && (
                                                        <div onClick={() => {
                                                            setIsShowMapModal(true)
                                                            if (userInfo && userInfo.length) {
                                                                setPosition([userInfo && userInfo[0].latitudes, userInfo && userInfo[0].longitudes])
                                                            }
                                                        }
                                                        } className="grid gap-6 mb-6 md:grid-cols-1 mt-4 py-1">
                                                            <div className="relative">
                                                                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-500 bg-gray-100 p-2 rounded rounded-lg">ثبت موقعیت مکانی روی نقشه</label>
                                                                <img src="/icons/arrowLeft.svg" className="absolute top-1 left-0" alt="" />
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                <div className="w-full flex items-center justify-center mb-2">
                                                    <button onClick={handleSubmit} type="submit" className="p-2 bg-blue-500 rounded rounded-lg text-white px-6">اعمال تغییرات</button>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                ) : <Loader />
                            }
                        </div>
                    </>
                )
            }

            <div className={`h-screen flex items-start justify-start z-50 p-2 fixed w-full top-0  bg-white transition-all ${isShowMapModal ? 'right-[0px]' : 'right-[10000px]'}`}>
                <div className={`h-[60%]  w-full right-0 map-container-in-profile bg-white transition-all `}>
                    <div className="p-1">
                        <img src="/icons/close-black.svg" alt="close" onClick={() => {
                            setIsShowMapModal(false)
                        }} />
                    </div>

                    <div className='relative h-full'>
                        <MapToPutMarker2 zoom="5" setUserLocation={setUserLocation} initialLocation={position} userCurrentLoc={userCurrentLoc} setUserCurrentLoc={setUserCurrentLoc}  />
                        <img src='/icons/current-location2.svg' alt="Current Location" className='absolute z-[1000] bottom-2 right-2 ' onClick={() => handleGetCurrentLocation()} />
                    </div>
                    <div>
                        <button className="border bg-green-500 hover:bg-green-400 rounded text-white mt-2 px-3 w-full" onClick={sendSelectedLocation}>تایید</button>
                    </div>
                </div>
            </div>

            {isSuccessEdit && (
                <div className={`fade-in z-50 fixed bottom-0 w-full h-full flex items-center justify-center backdrop-blur-sm`}>
                    <div className='rounded-xl p-4 successAlert text-white flex flex-col items-center justify-center gap-4 w-[80%] shadow-sm relative bg-modal-green'>
                        <p className='text-xl font-bold'>با موفقیت انجام شد</p>
                    </div>
                </div>
            )}

            <div onClick={(e) => closeModalClickOutside(e)} className={`${openProfile ? "top-0" : "top-[1500px]"} w-full h-screen  transition-all flex justify-center items-center 
            gap-3  modal border border-3 border-green-500 mt-3 backdrop-blur-sm fixed style-for-open-on-outside-profil`}>
                <div className={`flex z-50 justify-center bg-white flex-col text-center sm:w-full md:w-full  w-[25%] rounded
                     p-4 fixed  shadow-[0px_-1px_10px_1px_#000000] bg-white`}>
                    <div className="flex justify-around items-center mt-2 ">
                        <button onClick={() => removeProfilePic()} className="flex w-[110px] h-[30px] mx-2 justify-center gap-2 rounded bg-red-500 px-1 py-1 text-white text-sm items-center">
                            <img src="icons/trashWhite.svg" className="w-4 h-4" alt="" />
                            <p>حذف عکس</p>
                        </button>
                        <input
                            onChange={(e) => {
                                handleChange(e)
                            }}
                            type="file"
                            name="file-input"
                            id="file-input"
                            class="file-input__input"
                        />
                        <label class="file-input__label" for="file-input">
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="upload"
                                class="svg-inline--fa fa-upload fa-w-16"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                                ></path>
                            </svg>
                            <span>بارگذاری تصویر</span>
                        </label>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withAuth(EditProfileBusiness);